import LegacyUnit from 'scripts/defa/legacy/model-legacy-unit';

/**
 * defa.collections.LegacyUnits
 * A collection of LegacyUnits.
 * @version 1.2.0
 */
const LegacyUnits = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: LegacyUnit,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default LegacyUnits;